import classNames from "classnames";

import Checkbox from "rivals/components/shared/Form/Checkbox";
import { setData } from "rivals/shared/utils/qa";
import styles from "./DebitAgreement.module.scss";
import strings from "./strings";
import { OwnProps } from "./types";

const { agree } = strings;

function DebitAgreement({
  className,
  debitTerms,
  debitAgreedState
}: OwnProps): JSX.Element {
  const termsClasses = classNames(styles.terms, className);
  const [isDebitAgreed, setIsDebitAgreed] = debitAgreedState;

  return (
    <>
      <div
        className={termsClasses}
        dangerouslySetInnerHTML={{ __html: debitTerms }}
        {...setData("edit-billing-info", "debit-card-terms")}
      />
      <Checkbox
        className={styles.debitAgree}
        data="edit-billing-info-debit-terms-agree"
        isChecked={isDebitAgreed}
        label={agree}
        labelClassName={styles.optInLabel}
        onChange={(): void => {
          setIsDebitAgreed(!isDebitAgreed);
        }}
      />
    </>
  );
}

export default DebitAgreement;
